<span [ngClass]="['badge', 'text-capitalize', 'p-1', class]"><ng-content></ng-content></span>
